"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var BarHor_1 = __importDefault(require("atomicComponents/atoms/Graphs/BarHor"));
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var BarHorTitle_1 = __importDefault(require("atomicComponents/organisms/Text/BarHorTitle"));
var Money_1 = __importDefault(require("components/Money"));
var SavingsOpportunitiesList = function (_a) {
    var item = _a.item, forecastSpend = _a.forecastSpend, savings = _a.savings;
    var scaleMaxPx = 250; // maxWidth for each chart, don't change
    var scaleMax = forecastSpend;
    var rangeMin = scaleMax - savings;
    var pixelScale = scaleMax / scaleMaxPx;
    var bar1 = rangeMin / pixelScale;
    var bar2 = (scaleMax - rangeMin) / 500;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ width: 150 }, { children: (0, jsx_runtime_1.jsx)(LogoAndName_1.default, { url: "/saas-audit/savings", brand: item }) })), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ display: "flex", justifyContent: "flex-end", width: 250 }, { children: (0, jsx_runtime_1.jsx)(BarHor_1.default, __assign({ width: bar1, size: "regular", color: "pink", roundedCornerLeft: true, align: "right" }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: forecastSpend - savings, isShortened: "NEW" }) })) })), (0, jsx_runtime_1.jsx)(Box_1.default, { height: 48, width: 2, sx: { backgroundColor: 'grey[300]' } }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(BarHor_1.default, { width: bar2, size: "regular", color: "pink", roundedCornerRight: true, opacity: 0.55 }), (0, jsx_runtime_1.jsx)(BarHorTitle_1.default, { value: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: savings, isShortened: "NEW" }) })] }))] }))] })));
};
exports.default = SavingsOpportunitiesList;
